var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-box"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("../assets/images/cj2024.jpg?1.2"),"alt":""}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793e8f66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bannerView.vue
// module id = null
// module chunks = 